import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Badge, Collapse, Card } from 'react-bootstrap';
import { REGULATORY_DATA } from '../models/CTISProjectModel';

export default function CTISProjectDashboard({ controller, onManage }) {
  const [isExpanding, setIsExpanding] = useState(false);
  const [formData, setFormData] = useState({ productName: '', submissionDate: '', therapeuticArea: '', category: '' });

  const submitNewProject = () => {
    controller.handleRegister(formData);
    setIsExpanding(false); // Collapse tray
  };

  return (
    <Card className="border-0 shadow-sm mb-4">
      <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center py-3">
        <h5 className="mb-0 fw-bold">Dossier Project Registry</h5>
        <Button variant="outline-light" size="sm" onClick={() => setIsExpanding(!isExpanding)}>
          {isExpanding ? "CLOSE FORM" : "+ NEW PROJECT"}
        </Button>
      </Card.Header>

      <Table hover responsive className="mb-0 align-middle">
        <thead className="table-light small text-uppercase">
          <tr>
            <th onClick={() => controller.handleSort('id')} style={{cursor: 'pointer'}}>ID ↕</th>
            <th onClick={() => controller.handleSort('productName')} style={{cursor: 'pointer'}}>Product Name ↕</th>
            <th>Submission Date</th>
            <th>Status</th>
            <th className="text-end px-4">Action</th>
          </tr>
        </thead>
        <tbody>
          {controller.projects.map(p => (
            <tr key={p.id}>
              <td className="fw-bold">{p.id}</td>
              <td>{p.productName}</td>
              <td>{p.submissionDate}</td>
              <td><Badge bg="info">{p.status}</Badge></td>
              <td className="text-end px-4">
                <Button variant="dark" size="sm" onClick={() => onManage(p.id)}>Workbench</Button>
              </td>
            </tr>
          ))}
          {controller.projects.length === 0 && !isExpanding && (
            <tr><td colSpan="5" className="text-center py-5 text-muted">No active projects found.</td></tr>
          )}
        </tbody>
      </Table>

      {/* EXPANSION TRAY: DROPS OUT THE BOTTOM */}
      <Collapse in={isExpanding}>
        <div className="p-4 bg-light border-top">
          <Row className="g-3">
            <Col md={4}><Form.Control size="sm" placeholder="Product Name" onChange={e => setFormData({...formData, productName: e.target.value})} /></Col>
            <Col md={4}><Form.Control size="sm" type="date" onChange={e => setFormData({...formData, submissionDate: e.target.value})} /></Col>
            <Col md={4}>
              <Form.Select size="sm" onChange={e => setFormData({...formData, therapeuticArea: e.target.value})}>
                <option>Therapeutic Area...</option>
                {REGULATORY_DATA.THERAPEUTIC_AREAS.map(a => <option key={a}>{a}</option>)}
              </Form.Select>
            </Col>
            <Col md={12} className="text-end">
              <Button variant="success" size="sm" className="fw-bold" onClick={submitNewProject}>SAVE PROJECT DNA</Button>
            </Col>
          </Row>
        </div>
      </Collapse>
    </Card>
  );
}